import React from 'react'
import {connect} from 'react-redux';
import { GoogleMap } from '@react-google-maps/api';

const AnyReactComponent = () => <i className="material-icons nav-icon" style={{color: '#fa8d42', fontSize: 40}}>&#xe0c8;</i>;


export class ModalLocalizacaoVeiculo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.localizacaoVeiculo && this.props.localizacaoVeiculo.latitude) {
            return (
                <div className="modal fade show" id='modalLocalizacaoVeiculo' role='dialog'
                     aria-labelledby='modalLocalizacaoVeiculo' aria-hidden='true' data-backdrop='static'>
                    <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5>Localização</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <i className="material-icons">
                                        &#xe5cd;
                                    </i>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div style={{height: '80vh', width: '100%'}}>
                                    <GoogleMap
                                        bootstrapURLKeys={{key: 'AIzaSyDnWjOH-hUCru0DpyyM2UuupKv6Fi6BlXE'}}
                                        defaultCenter={{
                                            lat: Number(this.props.localizacaoVeiculo.latitude),
                                            lng: Number(this.props.localizacaoVeiculo.longitude)
                                        }}
                                        defaultZoom={15}>
                                        <AnyReactComponent
                                            lat={Number(this.props.localizacaoVeiculo.latitude)}
                                            lng={Number(this.props.localizacaoVeiculo.longitude)}
                                        />
                                    </GoogleMap>
                                </div>
                                <div className="modal-footer">
                                    <button id="btn-cancelar-acesso-autos" className="btn btn-azul"
                                            data-dismiss="modal">
                                        Fechar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return '';
    }
}

export function mapStateToProps(state) {
    return {
        localizacaoVeiculo: state.localizacaoVeiculo,
    }
}

export default connect(mapStateToProps, {})(ModalLocalizacaoVeiculo)
